import { useEffect, useState } from "react";
import { Sun, Moon } from "@phosphor-icons/react";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";

export function ThemeToggle() {
  const auth = useAuth();
  const user = auth?.user;
  const [dark, setDark] = useState(() => (localStorage.getItem("trak-theme") || "dark") === "dark");

  // Adopt the signed-in user's saved preference once it loads, so it follows across devices.
  useEffect(() => {
    if (user?.theme === "light" || user?.theme === "dark") {
      setDark(user.theme === "dark");
    }
  }, [user?.theme]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("trak-theme", dark ? "dark" : "light");
  }, [dark]);

  const onToggle = (v) => {
    setDark(v);
    if (user) api.put("/auth/my-theme", { theme: v ? "dark" : "light" }).catch(() => {});
  };

  return (
    <div className="flex items-center gap-2" title="Toggle light / dark theme">
      <Sun size={14} weight="bold" className={dark ? "text-muted-foreground" : "text-white"} />
      <Switch data-testid="theme-toggle" checked={dark} onCheckedChange={onToggle} />
      <Moon size={14} weight="bold" className={dark ? "text-primary" : "text-sidebar-muted"} />
    </div>
  );
}
